import { apiRequest } from './apiRequest'

import type { EmbedToken } from '../models/client/powerbi'

const getEmbedToken = async (params: { token: string }): Promise<EmbedToken> => {
  try {
    const result = await apiRequest({
      method: 'GET',
      path: `/isr/embed-token`,
      token: params.token,
    })

    return result?.data
  } catch (error) {
    throw error
  }
}

export const isrClient = {
  getEmbedToken,
}
